import { Avatar, Box, Button, FormControl, Grid, IconButton, LinearProgress, MenuItem, Select, TextField, Typography } from '@mui/material';
import { TEXT_TITLE_COLOR } from '../../constants/colors';
import { useFormJiffyStaffController } from './controller/form';
import SwitchComponent from '../../components/switch';
import { MerchantUserModel } from '../../models/merchantUser';
import ConfirmDialog from '../../components/ConfirmDialog';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useTranslation } from 'react-i18next';
import { ProvinceModel } from '../../models/province.model';
import { DistrictModel } from '../../models/district.model';
interface Props {
  onClose: VoidFunction;
  selectedData: MerchantUserModel
  onFetchData: Function,
  setSelected: Function
}

const FormJiffyStaffView = ({ onClose, selectedData, onFetchData, setSelected }: Props) => {
  const controller = useFormJiffyStaffController({ onClose, selectedData, onFetchData, setSelected });
  const { t } = useTranslation("global");
  return (
    <>
      <LinearProgress sx={{ display: !controller.loadingFetchData ? "none" : "block" }} />
      <form onSubmit={(e) => controller.handleOpenConfirmForm(e)} style={{
        display: controller.loadingFetchData ? "none" : "block"
      }}>
        <IconButton onClick={onClose} sx={{ mb: 2 }}>
          <KeyboardBackspaceIcon />
        </IconButton>
        <Typography variant="h4" fontWeight="bold" color={TEXT_TITLE_COLOR}>
          {selectedData ? t("merchant_user_page.Update merchant") : t("merchant_user_page.Create merchant")}
        </Typography>
        <Grid container spacing={2} mt={1}>
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                paddingTop: 5,
                paddingBottom: 5,
                borderRadius: 5,
                boxShadow:
                  '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
              }}
            >
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <label htmlFor="image-input-admin">
                  <Avatar
                    src={controller.imageToShow}
                    alt=""
                    style={{ cursor: 'pointer', width: 150, height: 150, objectFit: 'contain' }}
                  />
                </label>
                <input
                  type="file"
                  id="image-input-admin"
                  onClick={(e: any) => {
                    e.target.value = '';
                  }}
                  onChange={controller.handleSelectedImage}
                  style={{ display: 'none' }}
                />
              </Box>
              <Box mt={2}>
                <Typography textAlign="center">Allowd *.jpeg,*.jpg,*.png</Typography>
                <Typography textAlign="center">Max size of 3.1 MB</Typography>
              </Box>
            </Box>
            {
              selectedData ? <Box
                sx={{ display: 'flex', justifyContent: 'center', mt: 1, alignItems: 'center', gap: 2 }}
              >
                <Typography>
                  <span style={{ color: 'green' }}>{t("merchant_user_page.Active")}</span> / <span>{t("merchant_user_page.Inactive")}</span>
                </Typography>
                <SwitchComponent value={controller.banValue} onChange={controller.handleBanUser} />
              </Box> : <Box></Box>
            }

          </Grid>
          <Grid item xs={12} md={8}>
            <Box
              sx={{
                p: 4,
                boxShadow:
                  '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                borderRadius: 5,
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Box sx={{ width: '100%' }}>
                    <Typography>{t("merchant_user_page.First name")}</Typography>
                    <TextField
                      fullWidth
                      margin='normal'
                      required
                      placeholder={t("merchant_user_page.Please enter first name") || ""}
                      inputRef={controller.firstName}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box sx={{ width: '100%' }}>
                    <Typography>{t("merchant_user_page.Last name")}</Typography>
                    <TextField
                      fullWidth
                      margin='normal'
                      required
                      placeholder={t("merchant_user_page.Please enter last name") || ""}
                      inputRef={controller.lastName}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box sx={{ width: '100%' }}>
                    <Typography>{t("merchant_user_page.Phone")}</Typography>
                    <TextField
                      fullWidth
                      margin='normal'
                      required
                      placeholder={"2099998888"}
                      inputRef={controller.tel}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box sx={{ width: '100%' }}>
                    <Typography>{t("merchant_user_page.Email")}</Typography>
                    <TextField
                      fullWidth
                      margin='normal'
                      placeholder={t("merchant_user_page.Please enter email") || ""}
                      inputRef={controller.email}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box sx={{ width: '100%' }}>
                    <Typography>{t("merchant_user_page.Province")}</Typography>
                    <FormControl fullWidth margin='normal'>
                      <Select value={controller.provinceValue} onChange={controller.handleSelectedProvince}>
                        {
                          controller.ProvinceData?.map((data: ProvinceModel) => (
                            <MenuItem key={data?.id} value={data?.provinceNameLA}>
                              {data?.provinceNameLA}
                            </MenuItem>
                          ))
                        }
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box sx={{ width: '100%' }}>
                    <Typography>{t("merchant_user_page.District")}</Typography>
                    <FormControl fullWidth margin='normal'>
                      <Select value={controller.districtsValue} onChange={controller.handleSelectedDistrict}>
                        {
                          controller.districtsData?.map((dis: DistrictModel) => (
                            <MenuItem key={dis?.districtCode} value={dis?.districtNameLA}>
                              {dis?.districtNameLA}
                            </MenuItem>
                          ))
                        }
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box sx={{ width: '100%' }}>
                    <Typography>{t("merchant_user_page.Village")}</Typography>
                    <TextField
                      fullWidth
                      margin='normal'
                      required
                      placeholder={t("merchant_user_page.Please enter village") || ""}
                      inputRef={controller.village}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box sx={{ width: '100%' }}>
                    <Typography>{t("merchant_user_page.Username")}</Typography>
                    <TextField
                      fullWidth
                      margin='normal'
                      required
                      placeholder={t("merchant_user_page.Please enter username") || ""}
                      inputRef={controller.userName}
                      disabled={selectedData !== null}
                    />
                  </Box>
                </Grid>
                {
                  selectedData ? <Box></Box> : <>
                    <Grid item xs={12} sm={6}>
                      <Box sx={{ width: '100%' }}>
                        <Typography>{t("Password")}</Typography>
                        <TextField
                          fullWidth
                          type='password'
                          margin='normal'
                          required
                          placeholder={t("merchant_user_page.Please enter password") || ""}
                          inputRef={controller.password}
                        />
                      </Box>
                    </Grid>
                  </>
                }
                <Grid item xs={12} sm={6}>
                  <Box sx={{ width: '100%' }}>
                    <Typography>{t("merchant_user_page.Role")}</Typography>
                    <FormControl fullWidth margin="normal">
                      <Select value={controller.roleAndPermissionValue} onChange={(e) => controller.handleChangeRoleAndPermission(e.target.value)}>
                        {controller.roleAndPermissionData.map((option) => (
                          <MenuItem key={option.id} value={option.id}>
                            {t(option.role_type.toLocaleLowerCase())}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>
              </Grid>
              {controller.errorMessage && <Typography color='error'>{controller.errorMessage}</Typography>}
              <Box mt={3} sx={{ display: 'flex', gap: 1, justifyContent: 'end' }}>
                <Button
                  type="submit"
                  variant="contained"
                  color='secondary'
                  sx={{ textTransform: 'none', width: 100, color: '#fff' }}
                >
                  {
                    selectedData ? t("Edit") : t("Create")
                  }
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
        <ConfirmDialog
          open={controller.openConfirm}
          title={selectedData ? t("Do you want to edit data?") : t("Do you want to create data?")}
          loading={controller.loadingConfirmForm}
          onCancel={controller.handleCloseConfirmForm}
          onConfirm={() => controller.handleSubmit()}
        />
      </form>
    </>
  );
};
export default FormJiffyStaffView;
